var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3499_5030",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1 0.5C7.10589 0.5 6.3 1.30589 6.3 2.3V9.86434C5.22396 10.4791 4.5 11.6282 4.5 12.9442C4.5 14.9079 6.11177 16.4998 8.1 16.4998C10.0882 16.4998 11.7 14.9079 11.7 12.9442C11.7 11.6282 10.976 10.4791 9.9 9.86434V2.3C9.9 1.30589 9.09411 0.5 8.1 0.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 9.86434L6.69686 10.559L7.1 10.3286V9.86434H6.3ZM9.9 9.86434H9.1V10.3286L9.50314 10.559L9.9 9.86434ZM7.1 2.3C7.1 1.74772 7.54772 1.3 8.1 1.3V-0.3C6.66406 -0.3 5.5 0.864063 5.5 2.3H7.1ZM7.1 9.86434V2.3H5.5V9.86434H7.1ZM5.3 12.9442C5.3 11.9302 5.85688 11.0389 6.69686 10.559L5.90314 9.16972C4.59103 9.91936 3.7 11.3261 3.7 12.9442H5.3ZM8.1 15.6998C6.5442 15.6998 5.3 14.4567 5.3 12.9442H3.7C3.7 15.3591 5.67935 17.2998 8.1 17.2998V15.6998ZM10.9 12.9442C10.9 14.4567 9.6558 15.6998 8.1 15.6998V17.2998C10.5207 17.2998 12.5 15.3591 12.5 12.9442H10.9ZM9.50314 10.559C10.3431 11.0389 10.9 11.9302 10.9 12.9442H12.5C12.5 11.3261 11.609 9.91936 10.2969 9.16972L9.50314 10.559ZM9.1 2.3V9.86434H10.7V2.3H9.1ZM8.1 1.3C8.65228 1.3 9.1 1.74772 9.1 2.3H10.7C10.7 0.864059 9.53594 -0.3 8.1 -0.3V1.3Z",
    fill: "#807E7D",
    mask: "url(#path-1-inside-1_3499_5030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70001 12.9441C9.70001 13.8094 8.98836 14.5194 8.10001 14.5194C7.21165 14.5194 6.50001 13.8094 6.50001 12.9441C6.50001 12.0787 7.21165 11.3688 8.10001 11.3688C8.98836 11.3688 9.70001 12.0787 9.70001 12.9441Z",
    fill: "#807E7D",
    stroke: "#807E7D",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10001 13.338L8.10001 3.06641",
    stroke: "#807E7D",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempIcon);
export default __webpack_public_path__ + "static/media/tempIcon.aed00c8816079752df541b9e10a0c0db.svg";
export { ForwardRef as ReactComponent };